import React, { FC } from "react";
import { Image, ImageContainer } from "./styles";

export interface IBannerImages {
  imageUrl: string;
  mobileImageUrl: string;
}

interface IProps {
  bannerImages?: IBannerImages;
  backgroundColor?: string;
}

const BreakBarrier: FC<IProps> = ({
  backgroundColor,
  bannerImages = { imageUrl: "", mobileImageUrl: "" },
}) => {
  const { imageUrl, mobileImageUrl } = bannerImages;

  return (
    <ImageContainer backgroundColor={backgroundColor}>
      <Image
        src=""
        webImageSrc={imageUrl}
        mobileImageSrc={mobileImageUrl}
        alt="break barriers"
      />
    </ImageContainer>
  );
};

export default BreakBarrier;
